import { isDefined } from 'notable-common';
import { z } from 'zod';
import { FlowEntityType } from '../entity/entityType.js';
/** A flow whose Start has no entity type can still read the trigger's record, so both type and ID may be left out. */
export const FlowTestStartEntitySchema = z
    .object({
    entityType: z.enum(FlowEntityType).optional(),
    /** Present for downstream context consumers but never fetched from the database. */
    entityId: z.uuid().optional(),
    /** Opaque because Primary and FHIR own the authoritative entity shapes. */
    record: z.record(z.string(), z.unknown()),
})
    .refine((entity) => isDefined(entity.entityType) === isDefined(entity.entityId), {
    message: 'A start entity needs both an entityType and an entityId, or neither',
});
/** Excludes organization and practice IDs because those belong to the run rather than the case. */
export const FlowTestStartPayloadSchema = z.object({
    entity: FlowTestStartEntitySchema.optional(),
    /** Uses a string type because flow-api owns the authoritative start-data enum. */
    startData: z
        .object({
        type: z.string().min(1),
        data: z.unknown(),
    })
        .optional(),
});
//# sourceMappingURL=startPayload.js.map